module.exports = __webpack_public_path__ + "img/home_bottom_bg.6035eceb.jpg";